export default __webpack_public_path__ + "static/media/nfo-banner-finance-comp.e8a555b0.jpg";